import { DomainNotificationsProviderAction, DomainNotificationsProviderState } from './types'

export function domainNotificationsProviderReducer(
    state: DomainNotificationsProviderState,
    action: DomainNotificationsProviderAction,
): DomainNotificationsProviderState {
    const next = { ...state }

    switch (action.type) {
        case 'loading:set': {
            next.loading = action.loading
            break
        }

        case 'notifications:set': {
            next.notifications = action.notifications
            break
        }
    }

    return next
}
